import { Box, FormControlLabel, Switch } from '@mui/material';
import React from 'react';

import { BORDER_GRAY } from '../../../theme';

/** Whether to show table and column names, for engineers. Off by default. */
export const ShowFieldNamesContext = React.createContext(false);

export const FieldNamesToggle: React.FC<{
  checked: boolean;
  onChange: (checked: boolean) => void;
}> = ({ checked, onChange }) => (
  <FormControlLabel
    control={
      <Switch
        size="small"
        checked={checked}
        onChange={(event) => onChange(event.target.checked)}
      />
    }
    label="Show field names"
  />
);

export const FieldName: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const show = React.useContext(ShowFieldNamesContext);
  if (!show) {
    return null;
  }
  return (
    <Box
      component="code"
      sx={{
        fontSize: 11.5,
        px: 0.75,
        py: 0.25,
        borderRadius: 0.5,
        border: `1px solid ${BORDER_GRAY}`,
        color: 'text.disabled',
      }}
    >
      {children}
    </Box>
  );
};
